import React, { useEffect, useState } from "react";
import { Col, Row, Accordion, Card, Button } from "react-bootstrap";
import { Input } from "../../../../../library/input";
import { useDispatch, useSelector } from "react-redux";
import { requestSearchSingleClient } from "../../../../../../redux/actions/clients";
import { sendErrorNotification } from "../../../../../universal/notifications/notifications";
import { auth } from "../../../../../../networking/firebase";
import { Label } from "../../../../../library/label";
import Text from "../../../../../library/text";

const Index = ({
  searchOrganizationNumber,
  setSearchOrganizationNumber,
  companyObject,
  setCompanyObject,
  clickSearchCompany,
}) => {
  const dispatch = useDispatch();

  const searchError = useSelector((state) => state.clients.searchClient.error);
  const searchLoading = useSelector(
    (state) => state.clients.searchClient.loading
  );
  const searchResults = useSelector(
    (state) => state.clients.searchClient.status
  );

  const [activeTab, setActiveTab] = useState("0");

  const handleCompanySearch = (e) => {
    if (e.key === "Enter") {
      if (
        searchOrganizationNumber &&
        String(searchOrganizationNumber.toString().replace(/ /g, "")).length ===
          9
      ) {
        dispatch(
          requestSearchSingleClient(
            parseInt(searchOrganizationNumber.toString().replace(/ /g, ""))
          )
        );
      }
    }
  };

  useEffect(() => {
    if (
      !searchLoading &&
      !searchError &&
      searchResults &&
      Object.keys(searchResults).length > 0
    ) {
      setActiveTab("1");

      const company = {
        addedBy: auth.currentUser.uid,
        type: "company",
        timestamp: null,
        logoUrl: null,
        general: {
          name: null,
          organizationNumber: searchOrganizationNumber,
          industry: null,
          employees: null,
          parentCompany: {
            id: null,
            infoUrl: null,
            name: null,
            organizationNumber: null,
          },
          established: null,
          shareCapital: null,
          roles: [],
          shareholders: [],
        },
        financials: {
          creditRating: {
            date: null,
            description: null,
            rating: null,
          },
        },
        address: {
          street: null,
          postalCode: null,
          city: null,
          coordinates: null,
          county: null,
          municipality: null,
          region: null,
        },
        contact: {
          phone: "",
          email: null,
          website: null,
        },
        social: {
          twitter: null,
          facebook: null,
        },
      };

      if (searchResults && searchResults.name) {
        company.general.name = searchResults.name;
      } else {
        company.general.name = null;
      }

      if (
        searchResults &&
        searchResults.industries &&
        searchResults.industries.length > 0
      ) {
        company.general.industry = searchResults.industries[0].name;
      } else {
        company.general.industry = null;
      }

      if (
        searchResults &&
        searchResults.legalInformation &&
        searchResults.legalInformation.employees
      ) {
        company.general.employees = searchResults.legalInformation.employees;
      } else {
        company.general.employees = null;
      }

      if (
        searchResults &&
        searchResults.legalInformation &&
        searchResults.legalInformation.parentCompany
      ) {
        company.general.parentCompany =
          searchResults.legalInformation.parentCompany;
      } else {
        company.general.parentCompany = null;
      }

      if (
        searchResults &&
        searchResults.legalInformation &&
        searchResults.legalInformation.establishedDate
      ) {
        company.general.established =
          searchResults.legalInformation.establishedDate;
      } else {
        company.general.established = null;
      }

      if (
        searchResults &&
        searchResults.legalInformation &&
        searchResults.legalInformation.shareCapital
      ) {
        company.general.shareCapital =
          searchResults.legalInformation.shareCapital;
      } else {
        company.general.shareCapital = null;
      }

      if (
        searchResults &&
        searchResults.roles &&
        searchResults.roles.length > 0
      ) {
        company.general.roles = searchResults.roles;
      } else {
        company.general.roles = null;
      }

      if (
        searchResults &&
        searchResults.shareHolders &&
        searchResults.shareHolders.length > 0
      ) {
        company.general.shareholders = searchResults.shareHolders;
      } else {
        company.general.shareholders = null;
      }

      if (
        searchResults &&
        searchResults.geography &&
        searchResults.geography.coordinate
      ) {
        company.address.coordinates = searchResults.geography.coordinate;
      }

      if (
        searchResults &&
        searchResults.geography &&
        searchResults.geography.address &&
        searchResults.geography.address.street &&
        searchResults.geography.address.houseNumber
      ) {
        company.address.street = `${searchResults.geography.address.street} ${searchResults.geography.address.houseNumber}`;
      }

      if (
        searchResults &&
        searchResults.geography &&
        searchResults.geography.address &&
        searchResults.geography.address.postCode
      ) {
        company.address.postalCode = searchResults.geography.address.postCode;
      }

      if (
        searchResults &&
        searchResults.geography &&
        searchResults.geography.address &&
        searchResults.geography.address.postArea
      ) {
        company.address.city = searchResults.geography.address.postArea;
      }

      if (
        searchResults &&
        searchResults.geography &&
        searchResults.geography.address &&
        searchResults.geography.region
      ) {
        company.address.region = searchResults.geography.region;
      }

      if (
        searchResults &&
        searchResults.geography &&
        searchResults.geography.address &&
        searchResults.geography.county
      ) {
        company.address.county = searchResults.geography.county;
      }

      if (
        searchResults &&
        searchResults.geography &&
        searchResults.geography.address &&
        searchResults.geography.municipality
      ) {
        company.address.municipality = searchResults.geography.municipality;
      }

      if (
        searchResults &&
        searchResults.creditRating &&
        Object.keys(searchResults.creditRating).length > 0
      ) {
        if (searchResults.creditRating.date) {
          company.financials.creditRating.date =
            searchResults.creditRating.date;
        }
        if (searchResults.creditRating.rating) {
          company.financials.creditRating.rating =
            searchResults.creditRating.rating;
        }
        if (searchResults.creditRating.description) {
          company.financials.creditRating.description =
            searchResults.creditRating.description;
        }
      } else {
        company.financials.creditRating = null;
      }

      if (searchResults && searchResults.contactPoints) {
        const allContactPoints = searchResults.contactPoints;
        for (var i = 0; i < allContactPoints.length; i++) {
          if (
            allContactPoints[i].type === "MobilePhone" ||
            allContactPoints.type === "Phone"
          ) {
            company.contact.phone = allContactPoints[i].value;
          } else if (allContactPoints[i].type === "Email") {
            company.contact.email = allContactPoints[i].value;
          } else if (
            allContactPoints[i].type === "WebAddress" &&
            allContactPoints[i].value.includes("facebook.com")
          ) {
            company.social.facebook = allContactPoints[i].value;
          } else if (
            allContactPoints[i].type === "WebAddress" &&
            allContactPoints[i].value.includes("twitter.com")
          ) {
            company.social.twitter = allContactPoints[i].value;
          } else if (
            allContactPoints[i].type === "WebAddress" &&
            !allContactPoints[i].value.includes(
              "twitter.com" &&
                !allContactPoints[i].value.includes("facebook.com")
            )
          ) {
            company.contact.website = allContactPoints[i].value;
          }
        }
      }

      setCompanyObject(company);
    }

    if (!searchLoading && searchError) {
      sendErrorNotification("Kunne ikke hente bedriftsinformasjon.");
    }
  }, [searchLoading, searchResults, searchError]);

  return (
    <div className="company-details-container">
      <Accordion
        className="company-accordion"
        defaultActiveKey="0"
        activeKey={activeTab}
      >
        <Card className="single-card top">
          <Card.Header className="card-header">
            <Accordion.Toggle
              className="card-toggle"
              as={Button}
              variant="link"
              eventKey="0"
              onClick={() => setActiveTab("0")}
            >
              Søk opp virksomhet <i class="fad fa-chevron-down"></i>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="0">
            <Card.Body className="card-body">
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    Organisasjonsnummer
                  </Label>
                  <div className="search-container">
                    <Input
                      format="organizationNumber"
                      onChange={(e) =>
                        setSearchOrganizationNumber(e.target.value)
                      }
                      onKeyDown={(e) => handleCompanySearch(e)}
                      value={searchOrganizationNumber}
                      placeholder="Skriv inn organisasjonsnummer"
                      type="text"
                    />
                    {searchLoading ? (
                      <i class="fas fa-circle-notch fa-spin loading-icon"></i>
                    ) : null}
                  </div>
                  <Text size="small">
                    Skriv inn og trykk enter for å hente informasjonen
                    automatisk.
                  </Text>
                </Col>
              </Row>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card className="single-card top">
          <Card.Header className="card-header">
            <Accordion.Toggle
              className="card-toggle"
              as={Button}
              variant="link"
              eventKey="1"
              onClick={() => setActiveTab("1")}
            >
              Generelt <i class="fad fa-chevron-down"></i>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="1">
            <Card.Body className="card-body">
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    Bedriftsnavn *
                  </Label>
                  <Input
                    value={
                      companyObject.general && companyObject.general.name
                        ? companyObject.general.name
                        : null
                    }
                    onChange={(e) =>
                      setCompanyObject({
                        ...companyObject,
                        general: {
                          ...companyObject.general,
                          name: e.target.value,
                        },
                      })
                    }
                    placeholder="Bedriftsnavn"
                    type="text"
                  />
                </Col>
              </Row>
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    Bransje *
                  </Label>
                  <Input
                    value={
                      companyObject.general && companyObject.general.industry
                        ? companyObject.general.industry
                        : null
                    }
                    onChange={(e) =>
                      setCompanyObject({
                        ...companyObject,
                        general: {
                          ...companyObject.general,
                          industry: e.target.value,
                        },
                      })
                    }
                    placeholder="Bransje"
                    type="text"
                  />
                </Col>
              </Row>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card className="single-card">
          <Card.Header className="card-header">
            <Accordion.Toggle
              className="card-toggle"
              as={Button}
              variant="link"
              eventKey="2"
              onClick={() => setActiveTab("2")}
            >
              Kontaktpunkter <i class="fad fa-chevron-down"></i>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="2">
            <Card.Body className="card-body">
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    E-postadresse
                  </Label>
                  <Input
                    value={
                      companyObject.contact && companyObject.contact.email
                        ? companyObject.contact.email
                        : null
                    }
                    onChange={(e) =>
                      setCompanyObject({
                        ...companyObject,
                        contact: {
                          ...companyObject.contact,
                          email: e.target.value,
                        },
                      })
                    }
                    placeholder="E-postadresse"
                    type="text"
                  />
                </Col>
              </Row>
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    Telefon
                  </Label>
                  <Input
                    international={true}
                    countryCallingCodeEditable={false}
                    format="phone"
                    value={String(companyObject.contact.phone)}
                    onChange={(e) =>
                      setCompanyObject({
                        ...companyObject,
                        contact: {
                          ...companyObject.contact,
                          phone: e,
                        },
                      })
                    }
                    placeholder="Telefon"
                    type="text"
                  />
                </Col>
              </Row>
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    Hjemmeside
                  </Label>
                  <Input
                    value={
                      companyObject.contact && companyObject.contact.website
                        ? companyObject.contact.website
                        : null
                    }
                    onChange={(e) =>
                      setCompanyObject({
                        ...companyObject,
                        contact: {
                          ...companyObject.contact,
                          website: e.target.value,
                        },
                      })
                    }
                    placeholder="Hjemmeside"
                    type="text"
                  />
                </Col>
              </Row>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card className="single-card">
          <Card.Header className="card-header">
            <Accordion.Toggle
              className="card-toggle"
              as={Button}
              variant="link"
              eventKey="3"
              onClick={() => setActiveTab("3")}
            >
              Sosiale medier <i class="fad fa-chevron-down"></i>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="3">
            <Card.Body className="card-body">
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    Facebook
                  </Label>
                  <Input
                    value={
                      companyObject.social && companyObject.social.facebook
                        ? companyObject.social.facebook
                        : null
                    }
                    onChange={(e) =>
                      setCompanyObject({
                        ...companyObject,
                        social: {
                          ...companyObject.social,
                          facebook: e.target.value,
                        },
                      })
                    }
                    placeholder="Facebook"
                    type="text"
                  />
                </Col>
              </Row>
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    Twitter
                  </Label>
                  <Input
                    value={
                      companyObject.social && companyObject.social.twitter
                        ? companyObject.social.twitter
                        : null
                    }
                    onChange={(e) =>
                      setCompanyObject({
                        ...companyObject,
                        social: {
                          ...companyObject.social,
                          twitter: e.target.value,
                        },
                      })
                    }
                    placeholder="Twitter"
                    type="text"
                  />
                </Col>
              </Row>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card className="single-card">
          <Card.Header className="card-header">
            <Accordion.Toggle
              className="card-toggle"
              as={Button}
              variant="link"
              eventKey="4"
              onClick={() => setActiveTab("4")}
            >
              Addresse <i class="fad fa-chevron-down"></i>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="4">
            <Card.Body className="card-body">
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    Gate
                  </Label>
                  <Input
                    value={
                      companyObject.address && companyObject.address.street
                        ? companyObject.address.street
                        : null
                    }
                    onChange={(e) =>
                      setCompanyObject({
                        ...companyObject,
                        address: {
                          ...companyObject.address,
                          street: e.target.value,
                        },
                      })
                    }
                    placeholder="Gate"
                    type="text"
                  />
                </Col>
              </Row>
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    Postnummer
                  </Label>
                  <Input
                    format="postal"
                    value={
                      companyObject.address && companyObject.address.postalCode
                        ? companyObject.address.postalCode
                        : null
                    }
                    onChange={(e) =>
                      setCompanyObject({
                        ...companyObject,
                        address: {
                          ...companyObject.address,
                          postalCode: e.target.value,
                        },
                      })
                    }
                    placeholder="Postnummer"
                    type="text"
                  />
                </Col>
              </Row>
              <Row className="info-row">
                <Col className="info-col">
                  <Label version={1} weight="bold">
                    Poststed
                  </Label>
                  <Input
                    value={
                      companyObject.address && companyObject.address.city
                        ? companyObject.address.city
                        : null
                    }
                    onChange={(e) =>
                      setCompanyObject({
                        ...companyObject,
                        address: {
                          ...companyObject.address,
                          city: e.target.value,
                        },
                      })
                    }
                    placeholder="Poststed"
                    type="text"
                  />
                </Col>
              </Row>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};

export default Index;
